module.exports = __webpack_public_path__ + "img/music.c44a24f0.png";